export function formatElapsed(seconds) {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
}

// src/utils/formatDate.js
export function formatMeetingDate(isoString) {
    const date = new Date(isoString);
    
    const options = { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    };
    
    let formatted = date.toLocaleDateString('en-US', options); // "January 4, 2026"
    
    // Add ordinal suffix (1st, 2nd, 3rd, 4th...)
    const day = date.getDate();
    const suffix = 
      day % 10 === 1 && day !== 11 ? 'st' :
      day % 10 === 2 && day !== 12 ? 'nd' :
      day % 10 === 3 && day !== 13 ? 'rd' :
      'th';
    
    formatted = formatted.replace(day, `${day}${suffix}`);
    
    return formatted; // e.g., "January 4th, 2026"
  }

  const pad2 = (n) => String(n).padStart(2, '0');

export const isoToLocalDateTime = (iso) => {
  const d = new Date(iso);
  const dateISO = toISODate(d); // you already import/use toISODate elsewhere
  const timeHHmm = `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
  return { dateISO, timeHHmm };
};

export function toISODate(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate())
      .toISOString()
      .split("T")[0];
  }